import React from "react";
import { Container, Typography, Box, Card, CardContent } from "@mui/material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const AppPrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5, backgroundColor: "#f8f9fe", minHeight: "100vh" }}>
      {/* Header matching App Header */}
      <Box sx={{ 
        backgroundColor: "#ffffff", 
        p: 2, 
        textAlign: "center", 
        borderBottom: "1px solid #f1f1f1",
        mb: 3 
      }}>
        <Typography variant="h5" sx={{ fontWeight: "800", color: "#1a1a1a" }}>
          Core Dialer - Privacy Policy
        </Typography>
      </Box>

      <Box sx={{ px: { xs: 2, md: 4 } }}>
        <Typography sx={{ fontSize: 13, color: "#7c7c7c", mb: 2, fontStyle: "italic" }}>
          Effective Date: January 26, 2026
        </Typography>

        {/* 1. Introduction */}
        <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mt: 3, mb: 1.5, letterSpacing: 0.5 }}>
          1. INTRODUCTION
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.6, textAlign: "justify", mb: 2 }}>
          <span style={{ fontWeight: "700" }}>Core Dialer</span> (“we,” “us,” or “our”) is a proprietary tool for authorized executives of <span style={{ fontWeight: "700" }}>VedhaNirvana Private Limited</span>. This policy explains how we collect and protect data within the Executive App, ensuring transparency regarding your lead management activities.
        </Typography>

        {/* 2. Data Collection & Usage */}
        <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mt: 3, mb: 1.5, letterSpacing: 0.5 }}>
          2. DATA COLLECTION & USAGE
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.6, textAlign: "justify", mb: 2 }}>
          The App is designed to facilitate lead management. To provide this service, we collect the following information:
        </Typography>

        {/* Lead Interaction Data */}
        <Card sx={{ backgroundColor: "#ffffff", p: 1, borderRadius: "15px", mt: 1.5, boxShadow: "0 2px 5px rgba(0,0,0,0.05)" }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <AssignmentIcon sx={{ color: "#5e27a7", fontSize: 20 }} />
              <Typography sx={{ fontSize: 14, fontWeight: "800", color: "#1a1a1a", ml: 1 }}>
                A. Lead Interaction Data
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4, mb: 1 }}>
              <span style={{ fontWeight: "700" }}>Usage:</span> We collect the status updates, remarks, and interaction outcomes you manually enter for each assigned lead.
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4 }}>
              <span style={{ fontWeight: "700" }}>Purpose:</span> To synchronize your work with the central database at <span style={{ color: "#5e27a7", fontWeight: "600" }}>https://be.corebankers.in</span> and ensure accurate reporting for your organization.
            </Typography>
          </CardContent>
        </Card>

        {/* Authentication Data */}
        <Card sx={{ backgroundColor: "#ffffff", p: 1, borderRadius: "15px", mt: 1.5, boxShadow: "0 2px 5px rgba(0,0,0,0.05)" }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <SecurityIcon sx={{ color: "#5e27a7", fontSize: 20 }} />
              <Typography sx={{ fontSize: 14, fontWeight: "800", color: "#1a1a1a", ml: 1 }}>
                B. Account & Profile Information
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4, mb: 1 }}>
              <span style={{ fontWeight: "700" }}>Details:</span> We store your name, executive ID, and professional contact details provided by your administrator.
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4 }}>
              <span style={{ fontWeight: "700" }}>Security:</span> This data is used solely for authentication and secure access to the lead database.
            </Typography>
          </CardContent>
        </Card>

        {/* Privacy Guarantee */}
        <Card sx={{ backgroundColor: "#ffffff", p: 1, borderRadius: "15px", mt: 1.5, boxShadow: "0 2px 5px rgba(0,0,0,0.05)" }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <VerifiedUserIcon sx={{ color: "#5e27a7", fontSize: 20 }} />
              <Typography sx={{ fontSize: 14, fontWeight: "800", color: "#1a1a1a", ml: 1 }}>
                C. Privacy Guarantee
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4, mb: 1 }}>
              <span style={{ fontWeight: "700" }}>Call Logs/Contacts:</span> This App does <span style={{ fontWeight: "700" }}>NOT</span> automatically read or upload your personal call logs or private device contacts.
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#1a1a1a", lineHeight: 1.4 }}>
              <span style={{ fontWeight: "700" }}>Location:</span> We do not track your real-time GPS location.
            </Typography>
          </CardContent>
        </Card>

        {/* 3. Data Transfers */}
        <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mt: 4, mb: 1.5, letterSpacing: 0.5 }}>
          3. DATA TRANSFERS & SECURITY
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.8, whiteSpace: "pre-line" }}>
          <span style={{ fontWeight: "700" }}>• Secure Transmission:</span> All data is transmitted using industry-standard SSL/TLS encryption.{"\n"}
          <span style={{ fontWeight: "700" }}>• Internal Use Only:</span> Your lead interaction data is shared exclusively with your employer (<span style={{ fontWeight: "700" }}>VedhaNirvana Private Limited</span>) for professional auditing.{"\n"}
          <span style={{ fontWeight: "700" }}>• No Third-Party Sales:</span> We do not sell or trade any user data to third-party advertisers.
        </Typography>

        {/* 4. Disclosure */}
        <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mt: 4, mb: 1.5, letterSpacing: 0.5 }}>
          4. CONSENT
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.6, textAlign: "justify" }}>
          By logging into the App and using the lead management features, you consent to the collection and syncing of professional lead-related data as described in this policy.
        </Typography>

        {/* 5. Retention */}
        <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mt: 4, mb: 1.5, letterSpacing: 0.5 }}>
          5. DATA RETENTION & DELETION
        </Typography>
        <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.6, textAlign: "justify" }}>
          Lead records and user logs are retained as long as your executive account remains active. Upon termination of service, access is revoked. You may request account deactivation via your IT Admin.
        </Typography>

        {/* 6. Contact Section */}
        <Box sx={{ 
          mt: 4, 
          p: 2, 
          backgroundColor: "#ffffff", 
          borderRadius: "15px", 
          borderLeft: "4px solid #5e27a7",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
        }}>
          <Typography sx={{ fontSize: 15, fontWeight: "800", color: "#5e27a7", mb: 1 }}>
            6. CONTACT INFORMATION
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#1a1a1a", lineHeight: 1.6 }}>
            VedhaNirvana Pvt Ltd<br />
            IT Compliance Department<br />
            Email: manager@corebankers.in<br />
            Website: https://corebankers.in
          </Typography>
        </Box>

        <Box sx={{ height: 60 }} />
      </Box>
    </Container>
  );
};

export default AppPrivacyPolicy;